var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z",
    fill: "#FFB54A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z",
    fill: "#FFB54A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.9981 19.9702V17.0302C14.9981 15.7602 15.7581 15.0002 17.0281 15.0002H19.9681C20.1581 15.0002 20.3281 15.0202 20.4981 15.0602C20.6081 14.5002 20.6681 13.9202 20.6681 13.3302C20.6681 8.55016 16.7781 4.66016 11.9981 4.66016C7.21812 4.66016 3.32812 8.55016 3.32812 13.3302C3.32812 18.1102 7.21812 22.0002 11.9981 22.0002C13.2081 22.0002 14.3581 21.7502 15.4081 21.3002C15.1481 20.9602 14.9981 20.5202 14.9981 19.9702Z",
    fill: "#FFB54A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.97 15H17.03C15.76 15 15 15.76 15 17.03V19.97C15 21.24 15.76 22 17.03 22H19.97C21.24 22 22 21.24 22 19.97V17.03C22 15.76 21.24 15 19.97 15ZM19.69 19.46L18.51 20.14C18.27 20.28 18.03 20.35 17.81 20.35C17.64 20.35 17.49 20.31 17.35 20.23C17.03 20.04 16.85 19.67 16.85 19.18V17.82C16.85 17.33 17.03 16.96 17.35 16.77C17.67 16.58 18.08 16.62 18.51 16.86L19.69 17.54C20.11 17.79 20.35 18.13 20.35 18.5C20.35 18.87 20.12 19.21 19.69 19.46Z",
    fill: "#FFB54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerStart);
export default __webpack_public_path__ + "static/media/timer-start.aafb548180351c65072c3b37984e45c2.svg";
export { ForwardRef as ReactComponent };